<template>
  <div>
    <select-date-header></select-date-header>
    <select-date-title :activeTab="activeTab"></select-date-title>
    <select-date-content @selectDate="selectDate"></select-date-content>
  </div>
</template>
<script>
import SelectDateHeader from '@/components/application/form/SelectDateHeader.vue';
import SelectDateContent from '@/components/application/form/SelectDateContent.vue';
import SelectDateTitle from '@/components/application/form/SelectDateTitle.vue';

import { mapGetters, mapMutations } from 'vuex';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
dayjs.locale('ko');

/**
 * 시작일자 선택 뷰
 * 신청서 별 다음 페이지 분기
 * */
export default {
  mixins: [applCdMixin],

  data: () => ({
    startDateResetFlag: false,
  }),
  computed: {
    ...mapGetters('ELA', ['GET_DATE_TYPE', 'GET_OTWORK_APPL_GUBUN']),
    activeTab() {
      if (
        ((this.isVacation || this.isReward) && this.GET_DATE_TYPE === 'D') ||
        this.isBizTrip
      ) {
        return 'S'; // 시작일자
      } else {
        return '날짜선택'; // 날짜선택
      }
    },
  },
  methods: {
    ...mapMutations('ELA', [
      'SET_APPL_YMD',
      'SET_APPL_YMD_WEEK',
      'SET_IN_OUT_YN',
      'SET_REST_HOUR',
      'SET_REQUEST_HOUR',
      'SET_HOL_OT_HOUR',
      'SET_BASIC_HOUR',
      'SET_OT_INFO_DIRECT_YN',
      'SET_DIRECT_REQUEST_HOUR',
      'SET_DIRECT_REST_HOUR',
      'SET_GNT_FILE_ESS_YN',
    ]),

    // 날짜 선택시
    async selectDate(sYmd) {
      if (this.isVacation || this.isReward) {
        this.nextStepVacation(sYmd);
      } else if (this.isOtWork) {
        // 초기화
        this.SET_IN_OUT_YN('Y');
        this.SET_REST_HOUR('0');
        this.SET_REQUEST_HOUR('0');
        this.SET_HOL_OT_HOUR('0'); //휴일 연장을 위하여 추가 EJKIM
        this.SET_BASIC_HOUR('0');
        this.SET_DIRECT_REQUEST_HOUR('0'); //2025.03.12 직접입력 신청시간 초기화
        this.SET_DIRECT_REST_HOUR('0'); //2025.03.12 직접입력 휴게시간 초기화
        await this.$store.dispatch('ELA/FETCH_OT_DIRECT_YN'); //2025.03.12 개인 근무유형별 연장근무 직접입력가능 여부 조회
        this.$router.push(routerNames.ConfirmOtWorkTime); // 연장근무 시간확인 화면
      } else if (this.isSchedule) {
        await this.$store.dispatch('ELA/FETCH_WORK_ORG_TIME_LIST'); //근무유형 근무시간 조회
        this.$router.push(routerNames.SelectSchedule); // 근무스케줄 선택 화면
      } else if (this.isAttend) {
        this.$router.push(routerNames.SelectTime); // 출퇴근시간선택
      } else if (this.isBizTrip) {
        this.$router.push(routerNames.EndDate); // 종료일자선택
      }
    },

    // 근태 다음 페이지
    async nextStepVacation(sYmd) {
      if (this.GET_DATE_TYPE === 'OD') {
        if (this.isReward) {
          await this.$store.dispatch('ELA/FETCH_REWARD_HOLI_CNT');
        } else if (this.isVacation) {
          await this.$store.dispatch('ELA/FETCH_HOLI_CNT');
          await this.$store.dispatch('ELA/FETCH_REST_CNT');
        }
        this.$router.push(routerNames.ExtraOptions); // 추가옵션 화면
      } else if (this.GET_DATE_TYPE === 'H') {
        this.SET_APPL_YMD(sYmd);
        this.SET_APPL_YMD_WEEK(dayjs(sYmd).format('ddd')); // 요일
        this.$router.push(routerNames.SelectTime); // 시간선택 화면
      } else {
        this.$router.push(routerNames.EndDate); // 종료일자
        this.SET_GNT_FILE_ESS_YN('N');
        await this.$store.dispatch('ELA/FETCH_GNT_FILE_ESS_YN'); //2025.03.19 근태별 파일첨부필수여부 체크
      }
    },
  },
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
  components: {
    SelectDateHeader,
    SelectDateContent,
    SelectDateTitle,
  },
};
</script>
<style></style>
